// Lightweight browser logger adapter (G16)
// Uses structured JSON-ish output via console but centralizes logging

type Meta = Record<string, unknown> | undefined;

function log(level: 'info' | 'warn' | 'error', msg: string, meta?: Meta): void {
  const payload = {
    t: new Date().toISOString(),
    level,
    msg,
    ...(meta ?? {}),
  };
  const line = JSON.stringify(payload);
  // Still writes to console, but through central adapter per G16
  if (level === 'error') {
    console.error(line);
  } else if (level === 'warn') {
    console.warn(line);
  } else {
    console.log(line);
  }
}

export const logger = {
  info: (msg: string, meta?: Meta) => log('info', msg, meta),
  warn: (msg: string, meta?: Meta) => log('warn', msg, meta),
  error: (msg: string, meta?: Meta) => log('error', msg, meta),
};
